/* eslint-disable max-len */
/* eslint-disable no-restricted-globals */
/* eslint-disable import/no-extraneous-dependencies */
/* eslint-disable no-else-return */
import {
    ModalNextProvider
} from '@jutro/components';
import {
    messages as commonMessages
} from 'gw-platform-translations';

import moment from 'moment';
import {
    DateUtil
} from 'gw-portals-util-js';
import _ from 'lodash';


function isLossEstimateReqdMandatory(haveLossEstimate) {
    if (_.isNull(haveLossEstimate)) {
        ModalNextProvider.showAlert({
            title: 'Error - Mandatory Field validation failed',
            message: 'Do you have a Loss Estimate? is Required',
            status: 'error',
            icon: 'mi-error-outline',
            confirmButtonText: commonMessages.ok
        }).catch(_.noop);
        return false;
    }
    return true;
}

function lossEstimateAmountValidation(haveLossEstimate, lossestimateAmt) {
    const re = new RegExp(/^(\d{1,16})(\.{0,1})(\d{0,2})?$/);
    if (haveLossEstimate && _.isUndefined(lossestimateAmt)) {
        ModalNextProvider.showAlert({
            title: 'Error: Loss Estimate Validation',
            message: 'Loss Estimate is required when "Do you have a Loss Estimate?" is selected as Yes',
            status: 'error',
            icon: 'mi-error-outline',
            confirmButtonText: commonMessages.ok
        }).catch(_.noop);
        return false;
    } else if (haveLossEstimate && _.isNull(lossestimateAmt)) {
        ModalNextProvider.showAlert({
            title: 'Error: Loss Estimate Validation',
            message: 'Loss Estimate is required when "Do you have a Loss Estimate?" is selected as Yes',
            status: 'error',
            icon: 'mi-error-outline',
            confirmButtonText: commonMessages.ok
        }).catch(_.noop);
        return false;
    } else if (haveLossEstimate && !isNaN(lossestimateAmt) && lossestimateAmt.length > 16) {
        ModalNextProvider.showAlert({
            title: 'Error: Loss Estimate Validation',
            message: 'Cannot have more than 16 digits before the decimal point',
            status: 'error',
            icon: 'mi-error-outline',
            confirmButtonText: commonMessages.ok
        }).catch(_.noop);
        return false;
    } else if (haveLossEstimate && !_.isUndefined(lossestimateAmt) && !re.test(lossestimateAmt)) {
        ModalNextProvider.showAlert({
            title: 'Error: Loss Estimate Validation',
            message: 'Loss Estimate is an Amount field and cannot accept alphanumeric values and it must be a money value, with a maximum of 16 digits to the left and 2 digits to the right of the decimal separator',
            status: 'error',
            icon: 'mi-error-outline',
            confirmButtonText: commonMessages.ok
        }).catch(_.noop);
        return false;
    } else if (haveLossEstimate && lossestimateAmt && lossestimateAmt < 1) {
        ModalNextProvider.showAlert({
            title: 'Error: Loss Estimate Validation',
            message: 'Value of Loss Estimate cannot be less than R1.0',
            status: 'error',
            icon: 'mi-error-outline',
            confirmButtonText: commonMessages.ok
        }).catch(_.noop);
        return false;
    } else return true;
}

function lossEstimateAmountIncludingVATValidation(haveLossEstimate, lossestimateAmt) {
    const re = new RegExp(/^(\d{1,16})(\.{0,1})(\d{0,2})?$/);
    if (haveLossEstimate && _.isUndefined(lossestimateAmt)) {
        ModalNextProvider.showAlert({
            title: 'Error: Loss Estimate(Inclusive VAT) Validation',
            message: 'Loss Estimate(Inclusive VAT) is required when "Do you have a Loss Estimate?" is selected as Yes',
            status: 'error',
            icon: 'mi-error-outline',
            confirmButtonText: commonMessages.ok
        }).catch(_.noop);
        return false;
    } else if (haveLossEstimate && _.isNull(lossestimateAmt)) {
        ModalNextProvider.showAlert({
            title: 'Error: Loss Estimate(Inclusive VAT) Validation',
            message: 'Loss Estimate(Inclusive VAT) is required when "Do you have a Loss Estimate?" is selected as Yes',
            status: 'error',
            icon: 'mi-error-outline',
            confirmButtonText: commonMessages.ok
        }).catch(_.noop);
        return false;
    } else if (haveLossEstimate && !isNaN(lossestimateAmt) && lossestimateAmt.length > 16) {
        ModalNextProvider.showAlert({
            title: 'Error: Loss Estimate(Inclusive VAT) Validation',
            message: 'Cannot have more than 16 digits before the decimal point',
            status: 'error',
            icon: 'mi-error-outline',
            confirmButtonText: commonMessages.ok
        }).catch(_.noop);
        return false;
    } else if (haveLossEstimate && !_.isUndefined(lossestimateAmt) && !re.test(lossestimateAmt)) {
        ModalNextProvider.showAlert({
            title: 'Error: Loss Estimate(Inclusive VAT) Validation',
            message: 'Loss Estimate(Inclusive VAT) is an Amount field and cannot accept alphanumeric values and it must be a money value, with a maximum of 16 digits to the left and 2 digits to the right of the decimal separator',
            status: 'error',
            icon: 'mi-error-outline',
            confirmButtonText: commonMessages.ok
        }).catch(_.noop);
        return false;
    } else if (haveLossEstimate && lossestimateAmt && lossestimateAmt < 1) {
        ModalNextProvider.showAlert({
            title: 'Error: Loss Estimate(Inclusive VAT) Validation',
            message: 'Value of Loss Estimate(Inclusive VAT) cannot be less than R1.0',
            status: 'error',
            icon: 'mi-error-outline',
            confirmButtonText: commonMessages.ok
        }).catch(_.noop);
        return false;
    } else return true;
}

function validateEffectiveAndExpiryDates(effective, expiration) {
    if (expiration && !effective) {
        ModalNextProvider.showAlert({
            title: 'Error',
            message: 'Please select a valid effective date',
            status: 'error',
            icon: 'mi-error-outline',
            confirmButtonText: commonMessages.ok
        }).catch(_.noop);
        return false;
    }
    if (effective && !expiration) {
        ModalNextProvider.showAlert({
            title: 'Error',
            message: 'Please select a valid expiration date',
            status: 'error',
            icon: 'mi-error-outline',
            confirmButtonText: commonMessages.ok
        }).catch(_.noop);
        return false;
    }
    if (effective && expiration) {
        const effectiveDate = moment(effective);
        const expirationDate = moment(expiration);

        if (effectiveDate.isAfter(expirationDate)) {
            ModalNextProvider.showAlert({
                title: 'Error',
                message: 'Effective date must be before expiration date',
                status: 'error',
                icon: 'mi-error-outline',
                confirmButtonText: commonMessages.ok
            }).catch(_.noop);
            return false;
        }
    }
    return true;
}

function vehicleRegistrationNoMandatory(vehRegNo) {
    if (_.isUndefined(vehRegNo) || _.isEmpty(vehRegNo)) {
        ModalNextProvider.showAlert({
            title: 'Error - Mandatory Field validation failed',
            message: 'Vehicle Registration Number is mandatory',
            status: 'error',
            icon: 'mi-error-outline',
            confirmButtonText: commonMessages.ok
        }).catch(_.noop);
        return false;
    }
    return true;
}

function vinnoAndEngNoMandatoryValidation(assessorCode, engineNo, vinNo) {
    if (assessorCode && (_.isUndefined(engineNo) || _.isUndefined(vinNo) || _.isEmpty(engineNo) || _.isEmpty(vinNo))) {
        ModalNextProvider.showAlert({
            title: 'Error - Mandatory Field validation failed',
            message: 'Vin Number and Engine Number is mandatory if Assessor code is selected as Yes',
            status: 'error',
            icon: 'mi-error-outline',
            confirmButtonText: commonMessages.ok
        }).catch(_.noop);
        return false;
    }

    return true;
}

function mandatoryFieldForTotalLoss(totalLoss, enatisCode, finOut) {
    if (totalLoss && (_.isUndefined(enatisCode) || _.isUndefined(finOut))) {
        ModalNextProvider.showAlert({

            title: 'Error - Mandatory Field validation failed',
            message: 'ENatis Code and Financial Outstanding is mandatory if Possible total Loss? is selected as Yes',
            status: 'error',
            icon: 'mi-error-outline',
            confirmButtonText: commonMessages.ok
        }).catch(_.noop);
        return false;
    }

    return true;
}

function lossDateValidation(effective, expiration, lossDate) {
    const currentDate = DateUtil.currentDate();
    const currDate = moment(currentDate);

    if (lossDate) {
        const lossDt = moment(lossDate);
        if (lossDt.isAfter(currDate)) {
            ModalNextProvider.showAlert({
                title: 'Error - Loss Date Validation',
                message: 'The Loss Date you have entered is a future date. Please correct the date entered.',
                status: 'error',
                icon: 'mi-error-outline',
                confirmButtonText: commonMessages.ok
            }).catch(_.noop);
            return false;
        }
        if (effective && expiration) {
            const lossDte = moment(lossDt);
            const effDate = moment(effective);
            const expirationDte = moment(expiration);
            if (!(lossDte.isSameOrAfter(effDate) && (lossDte.isSameOrBefore(expirationDte)))) {
                ModalNextProvider.showAlert({
                    title: 'Error - Policy Coverage Validation',
                    message: 'The Loss Date you have entered falls outside of the policy coverage date range. Please correct the dates or select the cancel button if this claim is no longer valid based on coverage dates.',
                    status: 'error',
                    icon: 'mi-error-outline',
                    confirmButtonText: commonMessages.ok
                }).catch(_.noop);
                return false;
            }
        }
    }
    return true;
}

// For BI
function mandatoryFieldSearchAddress(address) {
    if (_.isEmpty(address)) {
        ModalNextProvider.showAlert({
            title: 'Error - Mandatory Field validation failed',
            message: 'Missing required field "Search Address"',
            status: 'error',
            icon: 'mi-error-outline',
            confirmButtonText: commonMessages.ok
        }).catch(_.noop);
        return false;
    }

    return true;
}

function validateTwentyDigits(inputValue) {
    const numbersUptoTwentyDigits = new RegExp((/^([0-9]\d{0,19})(\.{0,1})(\d{0,2})$/));
    if (!numbersUptoTwentyDigits.test(inputValue)) {
        return false;
    }
    return true;
}

function validateTenDigits(inputValue) {
    const numbersUptoTenDigits = new RegExp((/^[0-9]\d{0,9}$/));
    if (!numbersUptoTenDigits.test(inputValue)) {
        return false;
    }
    return true;
}

function sumInsuredValidation(sumInsured) {
    if (_.isUndefined(sumInsured)) {
        ModalNextProvider.showAlert({
            title: 'Error - Mandatory Field validation failed',
            message: 'Missing required field "Sum Insured"',
            status: 'error',
            icon: 'mi-error-outline',
            confirmButtonText: commonMessages.ok
        }).catch(_.noop);
        return false;
    }
    if (!validateTwentyDigits(sumInsured)) {
        ModalNextProvider.showAlert({
            title: 'Error - Sum Insured Validation',
            message: 'It must be a money value, with a maximum of 2 digits to the right of the decimal separator',
            status: 'error',
            icon: 'mi-error-outline',
            confirmButtonText: commonMessages.ok
        }).catch(_.noop);
        return false;
    }

    return true;
}

function coverTypeValidation(coverType) {
    if (_.isUndefined(coverType) || _.isNull(coverType) || coverType === '') {
        ModalNextProvider.showAlert({
            title: 'Error - Mandatory Field validation failed',
            message: 'Missing required field "Cover Type"',
            status: 'error',
            icon: 'mi-error-outline',
            confirmButtonText: commonMessages.ok
        }).catch(_.noop);
        return false;
    }

    return true;
}

function indemnityPeriodValidation(indemnityPeriod) {
    if (_.isUndefined(indemnityPeriod)) {
        ModalNextProvider.showAlert({
            title: 'Error - Mandatory Field validation failed',
            message: 'Missing required field "Indemnity Period"',
            status: 'error',
            icon: 'mi-error-outline',
            confirmButtonText: commonMessages.ok
        }).catch(_.noop);
        return false;
    }
    if (!validateTenDigits(indemnityPeriod)) {
        ModalNextProvider.showAlert({
            title: 'Error - Indemnity Period validation failed',
            message: 'must be an integer with no more than 10 digits',
            status: 'error',
            icon: 'mi-error-outline',
            confirmButtonText: commonMessages.ok
        }).catch(_.noop);
        return false;
    }
    return true;
}

function relatedClaimValidation(relatedClaim) {
    if (_.isUndefined(relatedClaim) || relatedClaim === '' || _.isNull(relatedClaim)) {
        ModalNextProvider.showAlert({
            title: 'Error - Mandatory Field validation failed',
            message: 'Missing required field "Sasria Material Damage Claim Number"',
            status: 'error',
            icon: 'mi-error-outline',
            confirmButtonText: commonMessages.ok
        }).catch(_.noop);
        return false;
    }
    return true;
}

function materialDamageValidation(haveMaterialDamage) {
    if (_.isNull(haveMaterialDamage) || haveMaterialDamage === '' || _.isUndefined(haveMaterialDamage)) {
        ModalNextProvider.showAlert({
            title: 'Error - Mandatory Field validation failed',
            message: 'Missing required field "Material Damage"',
            status: 'error',
            icon: 'mi-error-outline',
            confirmButtonText: commonMessages.ok
        }).catch(_.noop);
        return false;
    }

    return true;
}

function contractNumberValidation(contractNumber) {
    if (_.isUndefined(contractNumber)) {
        ModalNextProvider.showAlert({
            title: 'Error - Mandatory field validation failed',
            message: 'Error: Contract Number is Required',
            status: 'error',
            icon: 'mi-error-outline',
            confirmButtonText: commonMessages.ok
        }).catch(_.noop);
        return false;
    }
    if (!validateTenDigits(contractNumber)) {
        ModalNextProvider.showAlert({
            title: 'Error: Contract Number Validation',
            message: 'Must be an integer with no more than 10 digit',
            status: 'error',
            icon: 'mi-error-outline',
            confirmButtonText: commonMessages.ok
        }).catch(_.noop);
        return false;
    }
    return true;
}

function contractLimitValidation(contractLimit) {
    if (_.isUndefined(contractLimit)) {
        ModalNextProvider.showAlert({
            title: 'Error - Mandatory field validation failed',
            message: 'Error : Contract Limit is Required',
            status: 'error',
            icon: 'mi-error-outline',
            confirmButtonText: commonMessages.ok
        }).catch(_.noop);
        return false;
    }

    const contarctLimitRegex = new RegExp(/^([0-9]\d{0,9})(\.{0,1})(\d{0,2})?$/);
    if (!contarctLimitRegex.test(contractLimit)) {
        ModalNextProvider.showAlert({
            title: 'Error: Contract Limit Validation',
            message: 'It must be a money value, with a maximum of 10 digits to the left and 2 digits to the right of the decimal separator',
            status: 'error',
            icon: 'mi-error-outline',
            confirmButtonText: commonMessages.ok
        }).catch(_.noop);
        return false;
    }
    return true;
}

function contractValueValidation(contractValue) {
    if (_.isUndefined(contractValue)) {
        ModalNextProvider.showAlert({
            title: 'Error - Mandatory field validation failed',
            message: 'Error : Contract Value is Required',
            status: 'error',
            icon: 'mi-error-outline',
            confirmButtonText: commonMessages.ok
        }).catch(_.noop);
        return false;
    }
    const contractValueRegex = new RegExp(/^([0-9]\d{0,9})(\.{0,1})(\d{0,2})?$/);
    if (!contractValueRegex.test(contractValue)) {
        ModalNextProvider.showAlert({
            title: 'Error: Contract Limit Validation',
            message: 'It must be a money value, with a maximum of 10 digits to the left and 2 digits to the right of the decimal separator',
            status: 'error',
            icon: 'mi-error-outline',
            confirmButtonText: commonMessages.ok
        }).catch(_.noop);
        return false;
    }
    return true;
}

function inceptionDateValidation(inceptionDate) {
    if (!inceptionDate) {
        ModalNextProvider.showAlert({
            title: 'Error - Mandatory field validation failed',
            message: 'Error: Inception Date is Required',
            status: 'error',
            icon: 'mi-error-outline',
            confirmButtonText: commonMessages.ok
        }).catch(_.noop);
        return false;
    }
    return true;
}

function durationMonthValidation(durationMonth) {
    if (!durationMonth) {
        ModalNextProvider.showAlert({
            title: 'Error - Mandatory field validation failed',
            message: 'Error: Duration Month is Required',
            status: 'error',
            icon: 'mi-error-outline',
            confirmButtonText: commonMessages.ok
        }).catch(_.noop);
        return false;
    }
    return true;
}

function validatePolicyLmtWithLE(policyLimit, lossEstimate) {
    if (lossEstimate > policyLimit) {
        ModalNextProvider.showAlert({
            title: 'Error - Loss Estimate validation failed',
            message: 'Error: Loss Estimate should be lower then the policy limit',
            status: 'error',
            icon: 'mi-error-outline',
            confirmButtonText: commonMessages.ok
        }).catch(_.noop);
        return false;
    }
    return true;
}

function isAttested(attested) {
    if (!attested) {
        ModalNextProvider.showAlert({
            title: 'Error - Attestation required',
            message: 'Please accept the attestation for STP claims',
            status: 'error',
            icon: 'mi-error-outline',
            confirmButtonText: commonMessages.ok
        }).catch(_.noop);
        return false;
    }
    return true;
}

function checkIfSAIdValid(idNumber) {
    if (idNumber) {
        let identityNumber = idNumber;
        if (!identityNumber.length) {
            return false;
        }
        identityNumber = identityNumber.replace(/\s/g, '');
        if (identityNumber.length < 10) {
            return false;
        }
        const lastDigit = Number(identityNumber[identityNumber.length - 1]);

        const reverseIdentityNumber = identityNumber
            .slice(0, identityNumber.length - 1)
            .split('')
            .reverse()
            .map((x) => {
                return Number(x);
            });

        let sum = 0;

        for (let i = 0; i <= reverseIdentityNumber.length - 1; i += 2) {
            reverseIdentityNumber[i] *= 2;
            if (reverseIdentityNumber[i] > 9) {
                reverseIdentityNumber[i] -= 9;
            }
        }

        sum = reverseIdentityNumber
            .reduce((acc, currValue) => (acc + currValue), 0);

        return (((sum + lastDigit) % 10) === 0);
    }
    return false;
}

function validateLossEstimateInclAndExclValues(lossEstimateProvided, lossEstimateExcl, lossEstimateIncl) {
    if (!lossEstimateProvided) {
        return true;
    }
    if ((_.isNaN(lossEstimateExcl) && _.isUndefined(lossEstimateExcl)) || (_.isNaN(lossEstimateIncl) && _.isUndefined(lossEstimateIncl))) {
        ModalNextProvider.showAlert({
            title: 'Error - Provide proper Loss Estimates',
            message: 'Error: Provide proper Loss Estimate(Excluding VAT) and Loss Estimate(Including VAT) amounts',
            status: 'error',
            icon: 'mi-error-outline',
            confirmButtonText: commonMessages.ok
        }).catch(_.noop);
        return false;
    }
    if (Number(lossEstimateIncl) < Number(lossEstimateExcl)) {
        ModalNextProvider.showAlert({
            title: 'Error - Loss Estimate validation failed',
            message: 'Error: Loss Estimate(Including VAT) cannot be lower than Loss Estimate(Excluding VAT) value',
            status: 'error',
            icon: 'mi-error-outline',
            confirmButtonText: commonMessages.ok
        }).catch(_.noop);
        return false;
    }
    return true;
}

function companyRegValidationCheck(regNumber) {
    if (_.isEmpty(regNumber)) {
        ModalNextProvider.showAlert({
            title: 'Error: Company Registration Number Validation',
            message: 'Please provide valid Company Registration Number(####/######/##). It is a  mandatory field.',
            status: 'error',
            icon: 'mi-error-outline',
            confirmButtonText: commonMessages.ok
        }).catch(_.noop);
        return false;
    }
    const companyRegNumber = new RegExp(/^([19|20]{2}[0-9]{2}[//]{1}[0-9]{6}[//]{1}[0-9]{2})?$/);
    if (!companyRegNumber.test(regNumber)) {
        ModalNextProvider.showAlert({
            title: 'Error: Company Registration Number Validation',
            message: 'Please provide valid Company Registration Number',
            status: 'error',
            icon: 'mi-error-outline',
            confirmButtonText: commonMessages.ok
        }).catch(_.noop);
        return false;
    }
    return true;
}

export {
    isLossEstimateReqdMandatory,
    lossEstimateAmountValidation,
    validateEffectiveAndExpiryDates,
    vehicleRegistrationNoMandatory,
    vinnoAndEngNoMandatoryValidation,
    mandatoryFieldForTotalLoss,
    lossDateValidation,
    mandatoryFieldSearchAddress,
    sumInsuredValidation,
    coverTypeValidation,
    indemnityPeriodValidation,
    relatedClaimValidation,
    materialDamageValidation,
    validateTenDigits,
    contractValueValidation,
    contractLimitValidation,
    contractNumberValidation,
    inceptionDateValidation,
    durationMonthValidation,
    checkIfSAIdValid,
    validatePolicyLmtWithLE,
    isAttested,
    validateLossEstimateInclAndExclValues,
    companyRegValidationCheck,
    lossEstimateAmountIncludingVATValidation
};